const truthyStrings = new Set(['true', '1', 'yes', 'y']);
const falsyStrings = new Set(['false', '0', 'no', 'n', '']);

export const isEpisodeFree = (value: boolean | string | number | null | undefined): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (truthyStrings.has(normalized)) {
      return true;
    }

    if (falsyStrings.has(normalized)) {
      return false;
    }

    return false;
  }

  return false;
};

export const isEpisodePremium = (value: boolean | string | number | null | undefined): boolean => {
  return !isEpisodeFree(value);
};
